module.exports = "<p>\r\n  Dashboard Pegada Gourmet, em breve!\r\n</p>\r\n"